<template>
  <v-sheet style="padding: 1rem 1rem">
    <h2 style="text-align: center">Otwórz teczke </h2>
   <v-form>
     <v-menu
         ref="menu"
         v-model="menu"
         :close-on-content-click="false"
         :nudge-right="40"
         :return-value.sync="date"
         lazy
         transition="scale-transition"
         offset-y
         full-width
         min-width="290px"
     >
       <template v-slot:activator="{ on }">
         <v-text-field
             v-model="date"
             label="Data otwarcia nowej teczki"
             prepend-icon="event"
             readonly
             v-on="on"
         ></v-text-field>
       </template>
       <v-date-picker v-model="date" no-title scrollable>
         <v-spacer></v-spacer>
         <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
         <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
       </v-date-picker>
     </v-menu>
     <v-btn @click="openBriefcase" color="green">Otwórz</v-btn>
     <slot name="actions"></slot>
   </v-form>
  </v-sheet>
</template>

<script>
import Messenger from "@/plugins/Messenger";
import SearchSort from "@/components/common/SearchSort";
export default {
  name: "Workers",
  props : ['worker'],
  components:{
    SearchSort
  },
  data(){
    return{
      date: new Date().toISOString().substr(0, 10),
      menu: false,
    }
},
  methods: {
    goToWorkersDocuments(briefcaseGuid){
      this.$router.push({name: 'documents-briefcase', params : {briefcaseGuid}})
    },
    openBriefcase(){
      if(this.date == new Date().toISOString().substr(0, 10)){
        this.date = new Date().toJSON().slice(0, 19).replace('T', ' ')
      }

      this.$http.post(`document/worker/${this.worker.guid}/open-briefcase`,{open_date : this.date})
          .then((data)=>{
            this.$emit('briefcase-opened',data.data)
            Messenger.emitSuccess("Teczka została otwarta")
          })
          .catch(()=>Messenger.emitError("Problem z otwarciem teczki"))
    }
  }
}
</script>

<style scoped>
.icon{
  cursor: pointer;
}
</style>